import React from 'react';

import { PinIcon } from '@vlabs/icons';
import { DropdownListItem } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './SetFaceAsCardFaceDropdownItem.module.sass';
import type { FaceId } from '@vlabs/api/luna-api/model';
import { usePatchCard } from '@vlabs/api/artemy/client';
import type { CardId } from '@vlabs/api/artemy/model';

interface SetFaceAsCardFaceDropdownItemProps {
  faceId: FaceId;
  cardId: CardId;
  onSetFaceAsCardFace: VoidFunction;
}

export function SetFaceAsCardFaceDropdownItemPoint3({
  faceId,
  cardId,
  onSetFaceAsCardFace,
}: SetFaceAsCardFaceDropdownItemProps): React.JSX.Element {
  const { t } = useTranslation();
  const patchCard = usePatchCard();

  const $setFaceAsCardFace = async () => {
    await patchCard.mutateAsync({ cardId, data: { main_face_id: faceId } });
    onSetFaceAsCardFace?.();
  };

  return (
    <DropdownListItem
      className={st.DropdownItem}
      label={t('monokit:set_card_main_face.set_as_main')}
      leftIcon={<PinIcon />}
      onClick={$setFaceAsCardFace}
    />
  );
}
